import { AxiosInstance } from 'axios';
import { ComputedLicenceResource } from './resources';

export default class ComputedLicence {
    private basePath = '/api/computed-licence';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get computed plan for user
    getForUser = async (userId: ID): Promise<ComputedLicenceResource> => {
        const { data } = await this.http.get(`${this.basePath}/user-space/${userId}`);
        return data;
    };
}
